// extracted by mini-css-extract-plugin
export default {"root":"RecentlyChangedSections_root__0+jud","link":"RecentlyChangedSections_link__Bi23M"};